import Layout from "../Shared/Layout";
import GetQuoteStep from "./GetQuoteStep";


const GetQuotePage = () => {
    return (
        <Layout>
            <GetQuoteStep/>
        </Layout>
    )
}

export default GetQuotePage;